import { useState, useEffect } from 'react';
import { useForm } from '@formspree/react';
import Title from '../layout/Title';
import { FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';
const Contact = () => {
  const [username, setUsername] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const [state, handleSubmit] = useForm("xovkbwjl");

  const emailValidation = () => {
    return String(email)
      .toLocaleLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
  };

  const handleSend = (e) => {
    e.preventDefault();
    if (username === "") return setErrMsg("Name is required!");
    if (phoneNumber === "") return setErrMsg("Phone number is required!");
    if (email === "") return setErrMsg("Please provide your email!");
    if (!emailValidation(email)) return setErrMsg("Please provide a valid email!");
    if (subject === "") return setErrMsg("Subject is required!");
    if (message === "") return setErrMsg("Message is required!");
    setErrMsg("");

    
    handleSubmit(e);

    if (state.errors && state.errors.length > 0) {
      setErrMsg("Something went wrong. Please try again.");
    }

    setSuccessMsg(`Thank you, ${username}! Your message has been sent successfully.`);
    setUsername("");
    setPhoneNumber("");
    setEmail("");
    setSubject("");
    setMessage("");
  };




  useEffect(() => {
    if (successMsg || errMsg || state.succeeded || (state.errors && state.errors.length > 0)) {
      const timer = setTimeout(() => {
        setSuccessMsg("");
        setErrMsg("");
      }, 5000); 

      return () => clearTimeout(timer);
    }
  }, [successMsg, errMsg, state.succeeded, state.errors]);

  return (
    <section
      id='contacts'
      className='w-full py-20 border-b-[1px] border-b-black px-5'
    >
      <div className='items-center text-center justify-center'>
        <Title title='CONTACT ' des='Contact Me' />
      </div>
      <div className='w-full'>
        <div className='w-full h-auto flex flex-col lgl:flex-row justify-between gap-6'>
          <div className='w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] shadow-shadowOne p-4 lgl:p-8 rounded-lg flex flex-col gap-8 justify-center'>
            <img
              className='w-full h-64 object-cover rounded-lg mb-2'
              src={require('../../imgs/handshake.jpg')}
              alt='handshake'
            />
            <div className='flex flex-col gap-4'>
              <h3 className='text-3xl font-bold text-white'>Victor Okeke</h3>
              <p className='text-lg font-normal text-gray-400'>
                Web and Mobile App Developer
              </p>
              <p className='text-base text-gray-400 tracking-wide'>
                A versatile professional with over four years of experience in web development, customer service, data analysis, and digital content creation. Skilled in delivering excellent client support, creating engaging content, and driving brand growth through creativity and data-driven strategies.
              </p>
              <p className='text-gray-400 flex items-center gap-2'>
                {' '}
                Phone: <span className='text-lightText'>
                  +234 9029515921
                </span>{' '}
              </p>
              <p className='text-base text-gray-400 flex items-center gap-2 '>
                Email:{' '}
                <span className='text-lightText'>victorokeke64@gmail.com</span>
              </p>
            </div>
            <div className='flex flex-col gap-4'>
              <h2 className='text-base font-titleFont mb-4'>FIND ME IN</h2>
             <div className='flex gap-4 '>
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex item-center justify-center rounded-full shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor cursor-pointer duration-300'>
                <a href="https://www.facebook.com/victor.okeke.39589" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebook className='w-10 h-10' /></a>
              </span>
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex item-center justify-center rounded-md shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor cursor-pointer duration-300'>
                <a href="https://x.com/KenvicLeo" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter className='w-10 h-10' /></a>
              </span>
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex item-center justify-center rounded-md shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor cursor-pointer duration-300'>
                <a href="https://www.linkedin.com/in/victor-okeke-9450ba378" target="_blank" rel="noopener noreferrer" aria-label="Linkedin"><FaLinkedin className='w-10 h-10' /></a>
              </span>
            </div>
            </div>
          </div>

          <div className='w-full lgl:w-[60%] h-full py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] flex flex-col gap-6 p-4 lgl:p-9 rounded-lg shadow-shadowOne '>
            <form onSubmit={handleSend} className='w-full flex flex-col gap-4 lgl:gap-6 py-2 lgl-py-5'>
              {errMsg && (
                <p className='py-3 bg-gradient-to-r from-[#1e2024] to-[#23272b] shadow-shadowOne text-center text-orange-500 text-base tracking-wide animate-bounce'>
                  {errMsg}
                </p>
              )}
              {successMsg && (
                <p className='py-3 bg-gradient-to-r from-[#1e2024] to-[#23272b] shadow-shadowOne text-center text-green-500 text-base tracking-wide animate-bounce'>
                  {successMsg}
                </p>
              )}
              <div className='w-full flex flex-col lgl:flex-row gap-10'>
                <div className='w-full lgl:w-1/2 flex flex-col gap-4'>
                  <div>
                    <p className='uppercase text-sm text-gray-400 tracking-wide'>
                      Your Name
                    </p>
                  </div>
                  <input
                  name='username'
                    onChange={(e) => setUsername(e.target.value)}
                    value={username}
                    className={`${
                      errMsg === 'Username is Required!' &&
                      'outline-designColor'
                    } 'w-full h-12 rounded-lg border-b-[1px] border-b-gray-800 bg-[#191b1e] text-lightText px-4 active:outline-none focus-visible:outline-designColor outline-none focus-visible:border-b-transparent duration-300' `}
                    type='text'
                  />
                </div>
                <div className='w-full lgl:w-1/2 flex flex-col gap-4'>
                  <div>
                    <p className='uppercase text-sm text-gray-400 tracking-wide'>
                      Phone Number
                    </p>
                  </div>
                  <input
                  name='number'
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    value={phoneNumber}
                    className={`${
                      errMsg === 'Phone Number is Required!' &&
                      'outline-designColor'
                    } 'w-full h-12 rounded-lg border-b-[1px] border-b-gray-800 bg-[#191b1e] text-lightText px-4 active:outline-none focus-visible:outline-designColor outline-none focus-visible:border-b-transparent duration-300' `}
                    type='text'
                  />
                </div>
              </div>
              <div>
                <div className='w-full flex flex-col gap-4'>
                  <div>
                    <p className='uppercase text-sm text-gray-400 tracking-wide'>
                      Email
                    </p>
                  </div>
                  <input
                  name='email'
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    className={`${
                      errMsg === 'Please provide your Email!' &&
                      'outline-designColor'
                    } 'w-full h-12 rounded-lg border-b-[1px] border-b-gray-800 bg-[#191b1e] text-lightText px-4 active:outline-none focus-visible:outline-designColor outline-none focus-visible:border-b-transparent duration-300' `}
                    type='email'
                  />
                </div>
              </div>
              <div className='w-full flex flex-col gap-4'>
                <div>
                  <p className='uppercase text-sm text-gray-400 tracking-wide'>
                    Subject
                  </p>
                </div>
                <input
                name='subject'
                  onChange={(e) => setSubject(e.target.value)}
                  value={subject}
                  className={`${
                    errMsg === 'Please Provide a Subject!' &&
                    'outline-designColor'
                  } 'w-full h-12 rounded-lg border-b-[1px] border-b-gray-800 bg-[#191b1e] text-lightText px-4 active:outline-none focus-visible:outline-designColor outline-none focus-visible:border-b-transparent duration-300' `}
                  type='text'
                />
              </div>
              <div className='w-full flex flex-col gap-4'>
                <div>
                  <p className='uppercase text-sm text-gray-400 tracking-wide'>
                    Message
                  </p>
                </div>
                <textarea
                name='message'
                  onChange={(e) => setMessage(e.target.value)}
                  value={message}
                  className={`${
                    errMsg === 'Message is required!' && 'outline-designColor'
                  }  'w-full rounded-lg border-b-[1px] border-b-gray-600 bg-[#191b1e] text-lightText px-4 py-2 active:outline-none focus-visible:outline-designColor outline-none focus-visible:border-b-transparent duration-300 resize-none' `}
                  cols='30'
                  rows='8'
                ></textarea>
              </div>
              <div className='w-full'>
                <button
                type='submit'
                
                disabled={state.submitting}
                  className='w-full h-12 rounded-lg bg-[#141518] text-gray-400 tracking-wider
                hover:text-white text-base duration-300 hover:border-[1px] hover:border-designColor border-transparent'
                >
                  {state.submitting ? "Sending..." : "SEND MESSAGE"}
                </button>
              </div>
          
                {state.succeeded && (
                <p className="py-3 bg-gradient-to-r from-[#1e2024] to-[#23272b] shadow-shadowOne text-center text-green-500 text-base tracking-wide animate-bounce">{successMsg}</p>
              )}
              {state.errors && state.errors.length > 0 && (
                <p className="py-3 bg-gradient-to-r from-[#1e2024] to-[#23272b] shadow-shadowOne text-center text-orange-500 text-base tracking-wide animate-bounce">{errMsg}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Contact;
